import autoBind from 'react-autobind';
import {connect} from 'react-redux';
import {getCurrentUserId} from '../../authentication/selectors';
import {handleApiError} from '../../shared/services';
import {Map} from 'immutable';
import RaisedButton from 'material-ui/RaisedButton';
import {TextInput} from '../../shared/components';
import toastr from 'toastr';
import {withRouter} from 'react-router';

import {
  addNewComment,
  setCommentForm
} from '../actions';
import React, {Component, PropTypes} from 'react';

class AddNewComment extends Component {
  constructor(props, context) {
    super(props, context);

    autoBind(this);
  }

  componentDidMount() {
    const {userId, lessonPlanId} = this.props;

    this.props.onFieldChange('userId', userId);
    this.props.onFieldChange('lessonPlanId', lessonPlanId);
  }

  handleSubmitClick(event) {
    event.preventDefault();

    const {model, router} = this.props;

    this.props.addNewComment(model)
      .then(() => {
        toastr.success('Success.', 'Your comment has been submitted.', {timeout: 5000, allowHtml: true});
      })
      .catch(error => {
        handleApiError(error, router, 'An error occurred while attempting to submit a comment.', 'Error');
      });
  }

  handleFieldChange(event) {
    const {name, value} = event.target;
    this.props.onFieldChange(name, value);
  }

  render() {
    const {model, submitting} = this.props;

    return (
      <div className="add-new-comment-container">
        <form onSubmit={this.handleSubmitClick}>
          <div className="new-comment-section">
            <div className="comment-input">
              <TextInput
                id="text"
                multiLine
                fullWidth
                rows={1}
                rowsMax={4}
                value={model.get('text')}
                onChange={this.handleFieldChange}
                hintText="Add your thoughts..." />
            </div>

            <div className="comment-submit">
              <RaisedButton
                className="raised-button--rounded"
                type="submit"
                secondary
                disabled={submitting || !model.get('text')}>Submit</RaisedButton>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

AddNewComment.propTypes = {
  addNewComment: PropTypes.func.isRequired,
  lessonPlanId: PropTypes.string.isRequired,
  model: PropTypes.instanceOf(Map).isRequired,
  onFieldChange: PropTypes.func.isRequired,
  router: PropTypes.object.isRequired,
  submitting: PropTypes.bool.isRequired,
  userId: PropTypes.number.isRequired,
};

function mapStateToProps(state) {
  const {commentsSection} = state.features.comments.pages;

  return {
    model: commentsSection.get('model'),
    submitting: commentsSection.get('submitting'),
    userId: getCurrentUserId(state),
  };
}

export default withRouter(connect(
  mapStateToProps, {
    addNewComment,
    onFieldChange: setCommentForm,
  }
)(AddNewComment));



// WEBPACK FOOTER //
// ./app/features/comments/components/AddNewComment.js